import { defineStore } from 'pinia'
import { ref } from 'vue'
import { axiosClient } from '@/utils/axios-client'

import type { Organization } from '@/types/organization'

export const useCarrierStore = defineStore('carrier', () => {
  const organizationCarriers = ref<Organization[]>([])

  async function fetchOrganizationCarriers() {
    if (organizationCarriers.value.length > 0) {
      return
    }
    const response = await axiosClient.request<Organization[]>({
      url: '/auth/api/organisatie/search',
      method: 'GET',
    })

    organizationCarriers.value = response.data
  }

  return {
    organizationCarriers,
    fetchOrganizationCarriers,
  }
})
